<template>
	<main>
		<TopBottomLayout>
			<h6 class="layout">큰손들의 실제 보유종목</h6>
			<ResponsiveLayout_PaddingLeft>
				<SlideList
					v-if="getMajorHolderNameData"
					:data="getMajorHolderNameData.major_holder_name"
					:selected-pk="majorHolderPk"
					@update:major-holder-pk="onChangeMajorHolder"
				/>
			</ResponsiveLayout_PaddingLeft>
			<MajorHolderContent v-if="getMajorHolderNameData" :pk="majorHolderPk" />
		</TopBottomLayout>
	</main>
</template>

<script setup lang="ts">
// core
import { computed, onBeforeMount, ref, watch } from 'vue';
// lib
import { useRoute, useRouter } from 'vue-router';

import { useGetCheckAuthApi } from '@/api/auth';
// api
import { useGetMajorHolderNameApi } from '@/api/majorHolder';
import ResponsiveLayout_PaddingLeft from '@/components/layout/main/ResponsiveLayout_PaddingLeft.vue';
// component
import TopBottomLayout from '@/components/layout/main/TopBottomLayout.vue';
import SlideList from '@/components/rankList/SlideList.vue';

import MajorHolderContent from './MajorHolderContent.vue';

// -----variable-----
const router = useRouter();
const route = useRoute();
const majorHolderPk = ref();
// -----api-----
const { refetch: refetchCheckAuth } = useGetCheckAuthApi(
	computed(() => ({
		num: 'ALL',
		student: false,
		enable: false,
	}))
);
const { data: getMajorHolderNameData } = useGetMajorHolderNameApi();
// -----function-----
const onChangeMajorHolder = async (pk: number) => {
	router.push({
		query: { pk },
	});
	majorHolderPk.value = pk;
};

watch(
	() => getMajorHolderNameData.value,
	() => {
		if (getMajorHolderNameData.value && !route.query.pk) {
			majorHolderPk.value = getMajorHolderNameData.value.major_holder_name[0].major_holder_event_pk;
		} else {
			majorHolderPk.value = Number(route.query.pk);
		}
	},
	{ immediate: true }
);

onBeforeMount(async () => {
	const res = await refetchCheckAuth();
	if (!res.data?.success) {
		router.replace(`/subscribe/usa/not`);
	}
});
</script>

<style lang="scss" scoped>
.layout {
	@media screen and (max-width: 1280px) {
		padding-left: 2rem;
		padding-right: 2rem;
	}
}
.description-caution {
	color: var(--color-base-light);
	font-size: var(--font-s-small);
	font-weight: var(--font-w-light);
	line-height: 1.56rem;
}
</style>
